<div *ngIf="id">
  <app-paypal-native [id]="id"></app-paypal-native>
</div>
<div *ngIf="!id">

</div>
